import { useState } from 'react';

export default function Input(props) {
    const [value, setValue] = useState(props.attribs.value || '');
    function handleOnChange(event) {
        const value = event.target.value;
        props.attribs.onChange(props.name, value);
        setValue(() => value);
    }
    let element = <input />
    if ((props.attribs.type || 'text') === 'text') {
        element = <input
            name={props.name}
            className={props.attribs.className || ''}
            type={props.attribs.type || 'text'}
            placeholder={props.attribs.placeholder || ''}
            maxLength={props.attribs.maxLength || '100000'}
            value={value}
            onChange={handleOnChange}
        />
    }
    else if ((props.attribs.type || 'text') === 'textarea') {
        element = <textarea
            name={props.name}
            className={props.attribs.className || ''}
            placeholder={props.attribs.placeholder || ''}
            maxLength={props.attribs.maxLength || '100000'}
            value={value}
            onChange={handleOnChange}
        />
    }
    return (element);
}